import { types as t } from 'mobx-state-tree';

export const EventTvModel = t.model({
    id: t.number,
    name: t.string,
    date: t.Date
});
